import angularDirectiveToReact from 'Angular2reactHelper';
import { useAngularToReactRoute } from 'Angular2reactHelper/useAngularToReactRoute';

const CompleteRegistrationDirective = angularDirectiveToReact('completeRegistration', {});

export function CompleteRegistrationComponent() {
    const [key] = useAngularToReactRoute();
    return <CompleteRegistrationDirective key={key} />;
}
